function ActivityLogMain() {
  return null;
}

export default ActivityLogMain;
